var _path, _path2, _path3, _path4, _path5, _path6;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSdIcon02(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 53,
    viewBox: "0 0 53 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.41797 19.8751V14.3542C4.41797 8.8555 8.85672 4.41675 14.3555 4.41675H19.8763",
    stroke: "#cf3d31",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.125 4.41675H38.6458C44.1446 4.41675 48.5833 8.8555 48.5833 14.3542V19.8751",
    stroke: "#cf3d31",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M48.582 35.3333V38.6458C48.582 44.1445 44.1433 48.5833 38.6445 48.5833H35.332",
    stroke: "#cf3d31",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8763 48.5833H14.3555C8.85672 48.5833 4.41797 44.1446 4.41797 38.6458V33.125",
    stroke: "#cf3d31",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M37.5404 20.9792V32.0209C37.5404 36.4376 35.332 38.6459 30.9154 38.6459H22.082C17.6654 38.6459 15.457 36.4376 15.457 32.0209V20.9792C15.457 16.5626 17.6654 14.3542 22.082 14.3542H30.9154C35.332 14.3542 37.5404 16.5626 37.5404 20.9792Z",
    stroke: "#cf3d31",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M41.9596 26.5H11.043",
    stroke: "#cf3d31",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSdIcon02);
export default __webpack_public_path__ + "static/media/sd-icon02.2e329b1239c48ce1f1a13b0ae6ce07b6.svg";
export { ForwardRef as ReactComponent };